import { render, staticRenderFns } from "./RelatoriosEspecificos.vue?vue&type=template&id=45c06a6d"
import script from "./RelatoriosEspecificos.vue?vue&type=script&lang=js"
export * from "./RelatoriosEspecificos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports